import React from 'react';
import OrdersList from '@components/orders/OrdersList';
import {
  FlexColumn,
  FlexItem,
  FlexRow,
} from '@components/layout/FlexStyles';
import { TextRegularItalics, TextSmallItalics } from '@components/elements/TextStyles';

const OrdersCanceled = () => {

  return (
    <FlexColumn h_centered>
      <FlexItem>
        <TextRegularItalics color={'accent'}>Your purchase of SciScore Credits was canceled.</TextRegularItalics>
      </FlexItem>
      <FlexItem>
        <TextSmallItalics color={'secondary'}>Your list of prior orders are below.</TextSmallItalics>
      </FlexItem>
      <FlexRow height={'10px'}/>
      <FlexRow>
        <OrdersList />
      </FlexRow>
    </FlexColumn>
  );
};

export default OrdersCanceled;
